module.exports = __webpack_public_path__ + "img/5-2.71134ba4.jpg";